module.exports = __webpack_public_path__ + "media/images/page/ico_medal4-dfc6414947774fd546e0af794ca94d42.svg";